import React from 'react';

type Props = {
  href: string;
  onClick?: () => void;
  className?: string;
  /** Larger arrow circle (40px) for the pricing CTA. */
  large?: boolean;
  children: React.ReactNode;
};

/** Sage pill with a white circle holding an ink arrow, pinned right. */
const ArrowPill = ({ href, onClick, className = '', large = false, children }: Props) => (
  <a
    className={['bh-pill', large ? 'bh-pill--large' : '', className].filter(Boolean).join(' ')}
    href={href}
    onClick={onClick}
    target="_blank"
    rel="noopener noreferrer"
  >
    <span className="bh-pill__label">{children}</span>
    <span className="bh-pill__arrow" aria-hidden="true">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12h14M13 5l7 7-7 7" />
      </svg>
    </span>
  </a>
);

export default ArrowPill;
